class window.PageTabNavigation
  constructor: ->
    @tabPoints = $('.tab-window-navigation-js')
    @tabModal = $('.tab-window-navigation__modal-js')
    @tabNavLineContainer = $('.tab-window-navigation-js')
    @tabNavItemsContainer = $('.tab-window-navigation__modal-wrapper-js')
    @tabNavigationLinkItem = $('.tab-window-navigation__link-item-js')
    @tabNavigationLine = $('.tab-window-navigation__line-js')
    @interactiveWindow = $('.interactive-window-item-js')
    @tabBlockList = $('.js-tab-block')


    @initTabNavigation()


  initTabNavigation: ->
    self = this

    for tabBlock in self.tabBlockList
      name = $(tabBlock).data("name")
      tab_index = $(tabBlock).data("tab-index")

      self.addNewTab(name, tab_index)

    self.initActiveTab(0)
    setTimeout ->
      $('.tab-window-navigation__link-item-js, .tab-window-navigation__line-js').click (event) ->
        event.preventDefault()
        item_id = parseInt($(this).data('item-id'))

        tabBlockContent =  $("[data-tab-index=#{item_id}]")

        if $(tabBlockContent).hasClass('interactive-window-item-js')
          $('html, body').animate({
            scrollTop: 0
          }, 1000);
          self.toggleTabWindow(item_id)
          self.initActiveTab(item_id)
        else
          $('body').removeClass('body-overflow')
          $('html, body').animate({
            scrollTop: $(tabBlockContent).offset().top
          }, 1000);
          self.initActiveTab(tab_index)

    , 100


    $('.tab-window-navigation-js, .tab-window-navigation__modal-js').mouseenter ->
      self.animateModalWindow()
      $(this).addClass('mouse_over')
      self.tabModal.addClass('tab-window-navigation__modal--active')


  toggleTabWindow: (tab_id)->
    self = this

    $(self.interactiveWindow).removeClass('active')
    for windowItem in $(self.interactiveWindow)
      $(windowItem).addClass('active')

      interactiveWindowIndex = $(windowItem).data('interactive-window-index')

      if interactiveWindowIndex == tab_id
        break

    if window.interactiveWindow
      window.interactiveWindow.interactiveWindowNumber = tab_id

    window.interactiveWindow.loadAnimation()


  animateModalWindow: ->
    self = this
    animateElements = self.tabModal.find('.animate-element')

    index = 0
    for element in animateElements
      index += 1
      window.Animations.animateElement(element, index, 100, 'animate-element')


    $('.tab-window-navigation-js, .tab-window-navigation__modal-js').mouseleave ->
      $this = $(this)
      setTimeout(->
        $this.removeClass('mouse_over')
        if ($('.mouse_over').length == 0)
          self.tabModal.removeClass('tab-window-navigation__modal--active')
          $('.tab-window-navigation__link-item').addClass('animate-element')
      , 1)

  hideTabNavigation: ->
    self = this

    $(self.tabPoints).addClass('hide')
    setTimeout ->
      $(self.tabPoints).addClass('display-none')
    , 300

  showTabNavigation: ->
    $(self.tabPoints).removeClass('hide')
    setTimeout ->
      $(self.tabPoints).removeClass('display-none')
    , 300

  addNewTab: (itemName, itemId) ->
    self = this

    if itemId == 0
      activeClass = 'tab-window-navigation__line--active'
    else
      activeClass = ''

    templateTab = "<li class=\"tab-window-navigation__line tab-window-navigation__line-js #{activeClass}\" data-item-id=\"#{itemId}\"></li>"

    $(self.tabNavLineContainer).append(templateTab)

    templateItem = "<a class=\"tab-window-navigation__link-item tab-window-navigation__link-item-js text-with-animation-bg animate-element\" data-item-id=\"#{itemId}\"  href=\"\">#{itemName}</a>"

    tabItem = $(self.tabNavItemsContainer).append(templateItem)


  initActiveTab: (tabId)->
    $(".tab-window-navigation__link-item-js").removeClass('tab-window-navigation__link-item--active')
    $(".tab-window-navigation__line-js").removeClass('tab-window-navigation__line--active')


    $(".tab-window-navigation__link-item-js[data-item-id='#{tabId}']").addClass('tab-window-navigation__link-item--active')
    $(".tab-window-navigation__line-js[data-item-id='#{tabId}']").addClass("tab-window-navigation__line--active")


// WEBPACK FOOTER //
// ./assets/javascripts/app/page_tab_navigation.coffee